import { useRestaurant } from '@/entities/restaurant';
import { resolveEntityName, shortId } from '@/entities/moderation';

/**
 * Branch display name through the cached restaurant-detail query. Unresolved
 * ids fall back to their short form; no id reads as `—`.
 */
export function useBranchName(restaurantId: string | null | undefined): string {
  const id = restaurantId?.trim() ?? '';
  const { data: restaurant } = useRestaurant(id === '' ? undefined : id, id !== '');
  if (id === '') return '—';
  return resolveEntityName(restaurant?.name, shortId(id));
}
